import { Action } from '@ngrx/store';
import { HubDropReducer } from '../models/hubdrop.interface';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

export const UPDATE_LOCATIONT_TYPE = 'UPDATE_LOCATIONT_TYPE';
export const UPDATE_SELECTED_POST_OFFICE = 'UPDATE_SELECTED_POST_OFFICE';
export const REFRESH_HUBDROP = 'REFRESH_HUBDROP';
export const RESET_HUBDROP_REDUCER = 'RESET_HUBDROP_REDUCER';
export const SET_ZONE_ID = 'SET_ZONE_ID';

const initState: HubDropReducer = {
  selectedCollectionType: null,
  selectedPostOffice: null,
  zoneId: null,
}

export function hubDropReducer(state = initState, action: ActionWithPayloadInterface) {
  switch (action.type) {

    case UPDATE_LOCATIONT_TYPE:
      return Object.assign({}, state, { selectedCollectionType: action.payload });

    case UPDATE_SELECTED_POST_OFFICE:
      return Object.assign({}, state, { selectedPostOffice: action.payload });

    case SET_ZONE_ID:
      return Object.assign({}, state, { zoneId: action.payload });

    case REFRESH_HUBDROP:
      return Object.assign({}, action.payload);

    case RESET_HUBDROP_REDUCER:
      return Object.assign({}, initState);

    default:
      return state;
  }
}
